const calendarSelectTypes = {
  year: 'year',
  month: 'month',
};

const modalBodyStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

export { calendarSelectTypes, modalBodyStyle };
